import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RadioSliderComponent} from './radio-slider/radio-slider.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [RadioSliderComponent],
  exports: [RadioSliderComponent],
  providers: []
})
export class SlidersModule {
}
